function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "gift_module_svg__a",
  d: "M0 0h30v30H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "gift_module_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#gift_module_svg__a"
})), React.createElement("g", {
  fill: "#797D94",
  mask: "url(#gift_module_svg__b)"
}, React.createElement("path", {
  d: "M22.663 9H25a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-9H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2.337A3.5 3.5 0 0 1 10.5 4c1.96 0 3.421 1.168 4.439 3.018l.061.113.061-.113C16.08 5.168 17.54 4 19.5 4a3.5 3.5 0 0 1 3.163 5zM19.5 9a1.5 1.5 0 0 0 0-3c-1.102 0-1.985.707-2.686 1.982A8.153 8.153 0 0 0 16.346 9H19.5zm0 2H16v3h8v-3h-4.5zm-9 0H6v3h8v-3h-3.5zm0-2h3.154a8.154 8.154 0 0 0-.468-1.018C12.485 6.707 11.602 6 10.5 6a1.5 1.5 0 0 0 0 3zM16 24h6v-8h-6v8zm-2 0v-8H8v8h6z"
})));

var SvgGiftModule = function SvgGiftModule(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2);
};

export default SvgGiftModule;